const baseUrl = {
    'pl-PL': 'https://savicki.pl',
    'en-GB': 'https://savicki.com',
    'en-US': 'https://savicki.com',
    'cs-CZ': 'https://savicki.cz',
    'el-GR': 'https://savicki.gr',
    'hu-HU': 'https://savicki.hu',
    'sk-SK': 'https://savicki.sk',
    'ro-RO': 'https://savicki.ro',
    'bg-BG': 'https://savicki.bg',
    'de-DE': 'https://savicki.de',
    'hr-HR': 'https://savicki.hr',
}

const links = {
    'pl-PL': {
        '/': '',
        'o-nas': `o-nas`,
        'wartosci-savicki': `wartosci-savicki`,
        'nasze-salony': `nasze-salony`,
        'bizuteria-na-zamowienie': `bizuteria-na-zamowienie`,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `zwroty-i-reklamacje`,
        'karta-podarunkowa-savicki': `karta-podarunkowa-savicki`,
        'gwarancja': `gwarancja`,
        'wysylka-i-platnosci': `wysylka-i-platnosci`,
        'polityka-prywatnosci': `polityka-prywatnosci`,
        'regulamin': `regulamin`,
        'regulamin-karty-podarunkowej': `regulamin-karty-podarunkowej`,
        'najczesciej-zadawane-pytania-faq': `najczesciej-zadawane-pytania-faq`,
        'jak-kupowac': `jak-kupowac`,
        'jak-zmierzyc-rozmiar-pierscionka': `jak-zmierzyc-rozmiar-pierscionka`,
        'tabela-rozmiarow': `tabela-rozmiarow`,
        'skup-zlota': `skup-zlota`,
        'certyfikaty-jakosci': `certyfikaty-jakosci`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'en-US': {
        '/': '',
        'o-nas': `about-us`,
        'wartosci-savicki': `savicki-s-values`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `contact-us`,
        'status': `status`,
        'zwroty-i-reklamacje': `returns-and-claims`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `guarantee`,
        'wysylka-i-platnosci': `shipping-and-payment`,
        'polityka-prywatnosci': `personal-data-privacy-policy`,
        'regulamin': `terms-and-conditions-of-www-savicki-com-online-jewelry-store`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq-frequently-asked-questions`,
        'jak-kupowac': `how-to-shop-online`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `rings-and-wedding-rings-size-chart`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `quality-certificates`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'en-GB': {
        '/': '',
        'o-nas': `about-us`,
        'wartosci-savicki': `savicki-values`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `contact-us`,
        'status': `status`,
        'zwroty-i-reklamacje': `returns-and-claims`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `guarantee`,
        'wysylka-i-platnosci': `shipping-and-payment`,
        'polityka-prywatnosci': `privacy-policy`,
        'regulamin': `terms-and-conditions`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq`,
        'jak-kupowac': `how-to-shop-online`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `size-chart`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `quality-certificates`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'cs-CZ': {
        '/': '',
        'o-nas': `o-nas`,
        'wartosci-savicki': `hodnoty-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `vraceni-zbozi-a-reklamace`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `zaruka`,
        'wysylka-i-platnosci': `platby-a-dodani`,
        'polityka-prywatnosci': `ochrana-osobnich-udaju`,
        'regulamin': `obchodni-podminky`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq`,
        'jak-kupowac': `jak-nakupovat`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `tabulka-velikosti`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `certifikaty-kvality-diamantu`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'sk-SK': {
        '/': '',
        'o-nas': `o-nas`,
        'wartosci-savicki': `hodnoty-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `vratenie-a-reklamacia-tovaru`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `zaruka`,
        'wysylka-i-platnosci': `preprava-a-platba`,
        'polityka-prywatnosci': `ochrana-osobnych-udajov`,
        'regulamin': `obchodne-podmienky-eshopu-wwwsavickisk`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq-najcastejsie-otazky`,
        'jak-kupowac': `ako-nakupovat`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `velkostna-tabulka-prstenov-a-obrucok`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `certifikaty-kvality-diamantov`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'de-DE': {
        '/': '',
        'o-nas': `ueber-uns`,
        'wartosci-savicki': `savicki-werte`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `ruecksendungen-und-reklamationen`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `gewaehrleistung`,
        'wysylka-i-platnosci': `versand-und-zahlungen`,
        'polityka-prywatnosci': `datenschutzrichtlinie-fuer-personenbezogene-daten`,
        'regulamin': `allgemeine-geschaeftsbedingungen-www-savicki-de`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq-haeufig-gestellte-fragen`,
        'jak-kupowac': `wie-kaufe-ich-ein`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `groessentabelle-ringe-und-eheringe`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `qualitaetszertifikate-fuer-diamanten`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'ro-RO': {
        '/': '',
        'o-nas': `despre-noi`,
        'wartosci-savicki': `valorile-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `contact`,
        'status': `status`,
        'zwroty-i-reklamacje': `retur-si-reclamatii`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `garantie`,
        'wysylka-i-platnosci': `transport-si-plata`,
        'polityka-prywatnosci': `protectia-datelor-personale`,
        'regulamin': `conditiile-comerciale-ale-magazinului-online`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq-intrebari-frecvente`,
        'jak-kupowac': `cum-cumpar`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `tabel-marimi-inele-si-verighete`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `certificate-de-calitate-a-diamantului`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'hu-HU': {
        '/': '',
        'o-nas': `rolunk`,
        'wartosci-savicki': `a-savicki-ertekei`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kapcsolatfelvetel`,
        'status': `status`,
        'zwroty-i-reklamacje': `termek-visszakueldese-es-reklamacio`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `garancia`,
        'wysylka-i-platnosci': `szallitas-es-fizetes`,
        'polityka-prywatnosci': `adatvedelmi-nyilatkozat`,
        'regulamin': `a-www-savicki-hu-webaruhaz-altalanos-szerzodesi-feltetelei`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `gyik-gyakran-ismetelt-kerdesek`,
        'jak-kupowac': `hogyan-vasarolhat`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `gyuruk-es-jegygyuruk-merettablazata`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `gyemantok-minosegi-tanusitvanyai`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    },
    'bg-BG': {
        '/': '',
        'o-nas': `za-nas`,
        'wartosci-savicki': `stoynostite-na-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `reklamatsii-i-pretentsii`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `garantsia`,
        'wysylka-i-platnosci': `dostavka-i-plashtane`,
        'polityka-prywatnosci': `politika-za-poveritelnost-na-lichnite-danni`,
        'regulamin': `obshti-uslovia-na-onlayn-magazin-za-bijuta`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `chzv-chesto-zadavani-vaprosi`,
        'jak-kupowac': `kak-da-pazaruvate-onlayn`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `tablitsa-s-razmeri-na-prasteni-i-brachni-halki`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `sertifikati-za-kachestvo`,
        'conflict-free-diamonds': `bezkonfliktni-diamanti`,
    },
    'hr-HR': {
        '/': '',
        'o-nas': `o-nama`,
        'wartosci-savicki': `vrijednosti-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `obratite-nam-se`,
        'status': `status`,
        'zwroty-i-reklamacje': `povrati-i-potrazivanja`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `jamstvo`,
        'wysylka-i-platnosci': `otprema-i-placanje`,
        'polityka-prywatnosci': `pravila-o-privatnosti-osobnih-podataka`,
        'regulamin': `uvjeti-i-odredbe-www-savicki-hr-internetske-zlatarnice`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `faq-cesto-postavljana-pitanja`,
        'jak-kupowac': `kako-kupovati-putem-interneta`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `grafikon-velicine-prstena-i-vjencanih-prstena`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `certifikati-kvalitete`,
        'conflict-free-diamonds': `nekonfliktni-dijamanti`,
    },
    'el-GR': {
        '/': '',
        'o-nas': `schetika-me-emas`,
        'wartosci-savicki': `i-axies-tou-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `epikinonia`,
        'status': `status`,
        'zwroty-i-reklamacje': `epistrofes-kai-axiosis`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `eggiisi`,
        'wysylka-i-platnosci': `apostoli-kai-pliromi`,
        'polityka-prywatnosci': `politiki-prostasias-prosopikon-dedomenon`,
        'regulamin': `ori-kai-proipothesis-tou-ilektronikou-kosmimatopoliou-www-savicki-com`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': `sichnes-erotisis`,
        'jak-kupowac': `pos-na-psonisete-online`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `diagramma-megethon-dachtilidion-kai-veron-gamou`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `pistopiitika-piotitas`,
        'conflict-free-diamonds': `diamantia-choris-sigkrousis`,
    },
    'uk-UA': {
        '/': '',
        'o-nas': `pro-nas`,
        'wartosci-savicki': `tsinnosti-savicki`,
        'nasze-salony': ``,
        'bizuteria-na-zamowienie': ``,
        'kontakt': `kontakt`,
        'status': `status`,
        'zwroty-i-reklamacje': `povernennia-ta-reklamatsiji`,
        'karta-podarunkowa-savicki': ``,
        'gwarancja': `garantiia`,
        'wysylka-i-platnosci': `dostavka-ta-oplata`,
        'polityka-prywatnosci': `politika-konfidentsiynosti-danih`,
        'regulamin': `pravyla-mahazynu`,
        'regulamin-karty-podarunkowej': ``,
        'najczesciej-zadawane-pytania-faq': ``,
        'jak-kupowac': `iak-kupuvati`,
        'jak-zmierzyc-rozmiar-pierscionka': ``,
        'tabela-rozmiarow': `tablitsia-rozmiriv-kabluchok-ta-obruchok`,
        'skup-zlota': ``,
        'certyfikaty-jakosci': `sertifikati-iakosti-diamantiv`,
        'conflict-free-diamonds': `conflict-free-diamonds`,
    }
}

const socials = {
    'pl-PL': {
        'instagram': 'https://www.instagram.com/savickibizuteria/',
        'facebook': 'https://www.facebook.com/bizuteriasavicki',
        'linkedin': 'https://www.linkedin.com/company/savickibizuteria',
        'youtube': 'https://www.youtube.com/channel/UCTDdirZfiOWzuUDGbASM5Yg',
        'messenger': 'https://m.me/bizuteriasavicki',
        'livechat': 'https://direct.lc.chat/8478177/3',
        'whatsapp': null,
    },
    'en-US': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': null,
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/3',
        'messenger': 'https://m.me/savicki.jewellery',
        'whatsapp': null,
    },
    'en-GB': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/savickijewellery',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/3',
        'messenger': 'https://m.me/savicki.jewellery',
        'whatsapp': null,
    },
    'cs-CZ': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/klenotysavicki',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/5',
        'messenger': 'http://m.me/klenotysavicki',
        'whatsapp': null,
    },
    'sk-SK': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/savicki.sk',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/5',
        'messenger': 'http://m.me/savicki.sk',
        'whatsapp': null,
    },
    'de-DE': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/savickijewellery',
        'linkedin': null,
        'livechat': null,
        'messenger': null,
        'whatsapp': null,
    },
    'ro-RO': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/SavickiRomania',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/8',
        'messenger': 'http://m.me/SavickiRomania',
        'whatsapp': 'https://wa.me/40312296276',
    },
    'hu-HU': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/savicki.hu/',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/9',
        'messenger': 'http://m.me/savicki.hu',
        'whatsapp': 'https://wa.me/3618001923',
    },
    'bg-BG': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/SAVICKI.bg',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/11',
        'messenger': 'http://m.me/savicki.bg',
        'whatsapp': 'https://wa.me/35932540209',
    },
    'hr-HR': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/SAVICKI.hr',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/13',
        'messenger': 'http://m.me/savicki.hr',
        'whatsapp': null,
    },
    'el-GR': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': 'https://www.facebook.com/SAVICKI.gr',
        'linkedin': null,
        'livechat': 'https://direct.lc.chat/8478177/12',
        'messenger': 'http://m.me/savicki.gr',
        'whatsapp': null,
    },
    'uk-UA': {
        'instagram': 'https://www.instagram.com/savicki.1976',
        'facebook': null,
        'linkedin': null,
        'youtube': null,
        'messenger': null,
        'livechat': 'https://direct.lc.chat/8478177/27',
        'whatsapp': null,
    }
}

export const useLinks = () => {

    const currentLanguage = window.LANGUAGE

    const getLink = (slug) => {
        const link = links[currentLanguage]?.[slug];

        if (!link) {
            return null;
        }

        return `${baseUrl[currentLanguage]}/${link}`;
    }

    const getSocial = (slug) => {
        return socials[currentLanguage]?.[slug];
    }

    return {
        getLink,
        getSocial
    }
}